import { useTranslation } from 'react-i18next';
import { getMedia, hasPermission } from '../../../utils/HelperFunctions';
import SectionHeader from '../../../components/SectionHeader';
import { checkIcon, closeIcon, eyeIcon } from '../../../config/variables';
import { Fragment } from 'react/jsx-runtime';
import { useContext, useState } from 'react';
import ModalContainer from '../../../components/ModalContainer';
import ConfirmModal from '../../../components/ConfirmModal';
import { generalCreate } from '../../../API/api';
import { authContext } from '../../../store/context/authContext';
import SingleOrderPaymentReject from './SingleOrderPaymentReject';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';

export default function SingleOrderPayments({ data }: { data: any }) {
  const { t } = useTranslation();
  const { catchError } = useContext(authContext);
  const queryClient = useQueryClient()
  const [rejectLoading, setRejectLoading] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState<{
    opened: 'confirm' | 'reject' | null;
    id: number | null;
  }>({
    opened: null,
    id: null
  });

  const [rejectOpen, setRejectOpen] = useState<number | null>();

  const tableHeaders = [
    { label: t('date') },
    { label: t('amount') },
    { label: t('reference_number') },
    { label: t('transaction_id') },
    { label: t('type') },
    { label: t('status') },
    hasPermission(['orders.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  function handleStatusChange(values: any, id: number | null | undefined, handleSuccess: () => void) {
    if (!id) return;
    generalCreate({
      route: `/admin/payments/${id}`,
      values,
      method: 'patch'
    })
      .then(() => handleSuccess())
      .catch((error) => catchError(error));
  }

  return (
    <SectionHeader title={t('payments')}>
      <div className={`table_container lessColumns hasPagination`} style={{ marginBottom: '3rem' }}>
        <div className="table_header">
          {tableHeaders?.map(
            (header, index) =>
              header && (
                <span className={`head ${header.customClass}`} key={index}>
                  {header.label}
                </span>
              )
          )}
        </div>
        <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
          {data?.length > 0 ? (
            <>
              {data?.map((item: any, index: any) => (
                <div className="item has_logo orders" key={index}>
                  <div className="column">{item?.date || '-'}</div>
                  <div className="column">{Number(item?.amount)?.toLocaleString('en-US') || '-'}</div>
                  <div className="column">{item?.reference_number || '-'}</div>
                  <div className="column">{item?.transaction_id || '-'}</div>
                  <div className="column">{item?.type || '-'}</div>
                  <div className="column">{item?.status || '-'}</div>
                  {hasPermission(['orders.edit']) && (
                    <div className="column actions actions_col">
                      {getMedia(item?.media, 'proof_of_payment') && (
                        <div
                          className="action_btn edit"
                          onClick={(e) => {
                            window.open(getMedia(item?.media, 'proof_of_payment')?.url, '_blank');
                          }}
                        >
                          {eyeIcon}
                        </div>
                      )}
                      {item?.status_value == 0 ? (
                        <Fragment>
                          <div
                            className="action_btn edit"
                            onClick={(e) => {
                              setConfirmationModal({
                                opened: 'confirm',
                                id: item?.id
                              });
                            }}
                          >
                            {checkIcon}
                          </div>
                          <div
                            className="action_btn edit"
                            onClick={(e) => {
                              setRejectOpen(item?.id);
                            }}
                          >
                            {closeIcon}
                          </div>
                        </Fragment>
                      ) : getMedia(item?.media, 'proof_of_payment') ? null : (
                        '---'
                      )}
                    </div>
                  )}
                </div>
              ))}
            </>
          ) : (
            <h6>{t('no_payments')}</h6>
          )}
        </div>
      </div>
      {confirmationModal?.opened && (
        <ModalContainer small>
          <ConfirmModal
            closeModal={() => setConfirmationModal({ opened: null, id: null })}
            queryKey={'orders'}
            message={confirmationModal?.opened === 'confirm' ? t('are_you_sure_you_want_to_confirm_this_payment') : t('are_you_sure_you_want_to_reject_this_payment')}
            confirmFunc={(handleSuccess) => handleStatusChange(confirmationModal?.opened === 'confirm' ? { status: 1 } : { status: 2 }, confirmationModal?.id, handleSuccess)}
            successMsg={confirmationModal?.opened === 'confirm' ? t('payment_confirmed') : t('payment_rejected')}
          />
        </ModalContainer>
      )}
      {rejectOpen && (
        <ModalContainer small>
          <div className="common-modal">
            <SingleOrderPaymentReject
              setRejectOpen={setRejectOpen}
              submitSubmission={(values) => {
                setRejectLoading(true);
                handleStatusChange(values, rejectOpen, () => {
                  setRejectLoading(false);
                  setRejectOpen(null);
                  toast.success(t('payment_rejected'));
                  queryClient.invalidateQueries({ queryKey: ['orders'] });
                });
              }}
              loading={rejectLoading}
            />
          </div>
        </ModalContainer>
        //   <ConfirmModal
        //     closeModal={() => setConfirmationModal({ opened: null, id: null })}
        //     queryKey={'orders'}
        //     message={confirmationModal?.opened === 'confirm' ? t('are_you_sure_you_want_to_confirm_this_payment') : t('are_you_sure_you_want_to_reject_this_payment')}
        //     confirmFunc={(handleSuccess) => handleStatusChange(confirmationModal?.opened === 'confirm' ? 1 : 2, confirmationModal?.id, handleSuccess)}
        //     successMsg={confirmationModal?.opened === 'confirm' ? t('payment_confirmed') : t('payment_rejected')}
        //   />
        // </SingleOrderPaymentReject>
      )}
    </SectionHeader>
  );
}
